export default {
    bindings: {
        'basket': '=',
        'noedit': '<'
    },
    controller: 'basketItemsController',
    template: require('../views/basket.items.html')
};



// WEBPACK FOOTER //
// ./frontend/storefront/app/modules/basket/components/basket.items.component.js